interface TrophyProps {
  size?: number;
}

export function Trophy({ size = 128 }: TrophyProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        position: 'relative',
        filter: 'drop-shadow(0 0 24px rgba(244,199,36,0.7))',
        animation: 'pulse-scale 1.6s ease-in-out infinite',
      }}
    >
      <svg viewBox="0 0 100 100" width={size} height={size}>
        <defs>
          <linearGradient id={`tr-${size}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#ffe066" />
            <stop offset="50%" stopColor="#F4C724" />
            <stop offset="100%" stopColor="#a07c00" />
          </linearGradient>
        </defs>
        <path d="M 20 22 Q 10 22 10 36 Q 10 50 26 50" stroke={`url(#tr-${size})`} strokeWidth="6" fill="none" strokeLinecap="round" />
        <path d="M 80 22 Q 90 22 90 36 Q 90 50 74 50" stroke={`url(#tr-${size})`} strokeWidth="6" fill="none" strokeLinecap="round" />
        <path d="M 24 18 L 76 18 L 72 56 Q 72 64 50 64 Q 28 64 28 56 Z" fill={`url(#tr-${size})`} stroke="#a07c00" strokeWidth="2" />
        <path d="M 30 22 L 38 22 L 36 50 Q 36 54 32 54 Z" fill="rgba(255,255,255,0.5)" />
        <rect x="44" y="64" width="12" height="10" fill={`url(#tr-${size})`} />
        <rect x="30" y="74" width="40" height="6" rx="2" fill={`url(#tr-${size})`} />
        <rect x="26" y="80" width="48" height="10" rx="2" fill="#a07c00" />
        <circle cx="20" cy="10" r="2" fill="#fff" />
        <circle cx="80" cy="8" r="2.5" fill="#fff" />
        <circle cx="50" cy="4" r="1.5" fill="#fff" />
      </svg>
    </div>
  );
}
